/* This file is autogenerated, see readme.md for instructions */
import HtmlSvgIcon from '@bloomreach/banana-theme/icons/html.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const HtmlIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <HtmlSvgIcon />
    </Icon>
  );
});

HtmlIcon.displayName = 'HtmlIcon';

export default HtmlIcon;
